import { FormikContext } from "formik";
import React, { useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";
import {
  ContentWithImage,
  DoubleContent,
  Headline,
  Link,
  SectionContent,
  SelectControl,
  SwitchContent,
  Text,
} from "../../../../components";
import { AssembleiaGeralExtraordinariaForm } from "../../../../forms";
import DownloadsImg from "../../../../assets/images/consorcio/ilustracao-mulher-mostrando-passos-espelhado.svg";
import * as S from "./AssembleiaGeral.Style";
import { useStaticJsonRequest } from "../../../../hooks";
import { envs, links } from "../../../../config";
import { applyKey, distinctArray } from "../../../../utils";
import { ReactComponent as DownloadIcon } from "../../../../assets/images/icons/zeppelin-download-icon.svg";

const dataAGEImobiliarioList = [
  { label: "25/01/2018", value: "25/01/2018" },
  { label: "18/07/2018", value: "18/07/2018" },
];

const dataAGEVeiculosList = [
  { label: "04/07/2018", value: "04/07/2018" },
  { label: "21/11/2017", value: "21/11/2017" },
  { label: "15/08/2017", value: "15/08/2017" },
  { label: "22/01/2017", value: "22/01/2017" },
  { label: "19/10/2016", value: "19/10/2016" },
  { label: "14/09/2016", value: "14/09/2016" },
  { label: "23/03/2016", value: "23/03/2016" },
  { label: "20/01/2016", value: "20/01/2016" },
  { label: "30/01/2015", value: "30/01/2015" },
  { label: "14/05/2014", value: "14/05/2014" },
  { label: "04/04/2014", value: "04/04/2014" },
  { label: "27/02/2014", value: "27/02/2014" },
];

const consorcioImobiliarioContent = (
  <>
    <SelectControl
      name="data"
      placeholder="Selecione a data"
      options={dataAGEImobiliarioList}
      label="Data da AGE"
    />
  </>
);

const consorcioDeVeiculosContent = (
  <>
    <SelectControl
      name="data"
      placeholder="Selecione a data"
      options={dataAGEVeiculosList}
      label="Data da AGE"
    />
  </>
);

const FormAGE = ({ mapeamento }) => {
  const [contentActive, setContentActive] = useState("");
  const { values } = useContext(FormikContext);

  const DocumentsList = useMemo(() => {
    return distinctArray(
      mapeamento.filter(
        (item) => item.data === values.data && item.consorcio === contentActive
      )
    );
  }, [contentActive, mapeamento, values.data]);

  return (
    <>
      <DoubleContent
        leftContent={
          <>
            <Headline nivel="2" styleAs="3">
              Resultado da AGE
            </Headline>
            <Text>
              Consulte o resultado das Assembleias Gerais Extraordinárias e a
              substituição de bens descontinuados:
            </Text>
          </>
        }
        rightContent={
          <>
            <Text>Escolha o tipo de Consórcio</Text>
            <SwitchContent
              leftButton="Consórcio Imobiliário"
              rightButton="Consórcio de Veículos"
              leftContent={consorcioImobiliarioContent}
              rightContent={consorcioDeVeiculosContent}
              leftId="Imobiliário"
              rightId="Veículos"
              contentActive={contentActive}
              handleChange={(content) => setContentActive(content)}
            />
          </>
        }
      />

      {values.data && DocumentsList.length > 0 && (
        <S.DownloadsContent>
          <ContentWithImage
            imgSrc={DownloadsImg}
            imgAlt="Mulher indicando as atas disponíveis"
          >
            <S.TextTitleContent as={Text} textSize="sm">
              Atas disponíveis
            </S.TextTitleContent>
            <S.ItemsDownloadContent>
              {applyKey(DocumentsList, ({ ata, subtitulo, path }) => (
                <S.ItemDownload>
                  <div>
                    <Text textSize="sm">{ata}</Text>
                    <S.Subtitle as={Text} textType="caption">
                      {subtitulo}
                    </S.Subtitle>
                  </div>
                  <Link target="_blank" href={`${envs.hostStaticCdn}${path}`}>
                    <DownloadIcon />
                  </Link>
                </S.ItemDownload>
              ))}
            </S.ItemsDownloadContent>{" "}
          </ContentWithImage>
        </S.DownloadsContent>
      )}
    </>
  );
};

FormAGE.propTypes = {
  mapeamento: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.string.isRequired,
    })
  ).isRequired,
};

const AssembleiaGeral = () => {
  const { data: mapeamento } = useStaticJsonRequest(
    links.consorcio.mapaAssistenciaGeralExtraordinaria
  );
  return (
    <>
      <S.HeaderSection>
        <SectionContent>
          <Headline nivel="2" styleAs="3">
            Assembleia Geral Extraordinária (AGE)
          </Headline>
          <Text>
            Uma AGE pode ser convocada pela Caixa Seguradora ou pelo grupo, a
            qualquer momento, se for necessário mudar o prazo, unir ou desfazer
            grupos. Somente poderão votar os consorciados ativos que estejam com
            o pagamento das parcelas em dia.
          </Text>
          <Text>
            De acordo com o assunto da AGE, a votação pode ser limitada a
            consorciados ativos não-contemplados.
          </Text>
        </SectionContent>
      </S.HeaderSection>
      <SectionContent>
        <AssembleiaGeralExtraordinariaForm
          form={FormAGE}
          mapeamento={mapeamento || []}
        />
      </SectionContent>
    </>
  );
};

export default AssembleiaGeral;
